import { useState } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import ArticleCard from '../../components/base/ArticleCard';
import { useArticles } from '../../hooks/useArticles';

const Blog = () => {
  const [selectedCategory, setSelectedCategory] = useState('Tous');
  const { articles, loading, error } = useArticles();

  const categories = ['Tous', 'Guide', 'Alerte', 'Explication'];

  const filteredArticles =
    selectedCategory === 'Tous'
      ? articles
      : articles.filter((a) => a.category === selectedCategory);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      <div className="pt-32 pb-20">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-12">
            <h1 className="text-5xl font-serif font-bold text-[#1a1a1a] mb-6">
              Blog
            </h1>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Analyses, décryptages et documentation des mouvements citoyens et enjeux démocratiques
            </p>
          </div>

          <div className="flex flex-wrap justify-center gap-3 mb-16">
            {categories.map((category) => (
              <button
                key={category}
                onClick={() => setSelectedCategory(category)}
                className={`px-6 py-2 rounded-full font-medium transition-all whitespace-nowrap cursor-pointer ${
                  selectedCategory === category
                    ? 'bg-[#1a1a1a] text-white'
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                }`}
              >
                {category}
              </button>
            ))}
          </div>

          {loading && (
            <div className="text-center py-20">
              <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-[#1a1a1a]"></div>
              <p className="mt-4 text-gray-600">Chargement des articles...</p>
            </div>
          )}

          {error && (
            <div className="text-center py-20">
              <p className="text-red-600">Erreur : {error}</p>
            </div>
          )}

          {!loading && !error && (
            <>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                {filteredArticles.map((article) => (
                  <ArticleCard 
                    key={article.id} 
                    id={article.id}
                    slug={article.slug}
                    title={article.title}
                    excerpt={article.meta_description || article.content.substring(0, 150) + '...'}
                    image={article.image_url || 'https://public.readdy.ai/ai/img_res/b56b3dfd98a1b9ed80d6321a5614a55c.jpg'}
                    date={new Date(article.published_at).toLocaleDateString('fr-FR', { year: 'numeric', month: 'long', day: 'numeric' })}
                    readTime={article.readTime || '5 min'}
                    category={article.category || 'Article'}
                    categoryColor="bg-blue-100 text-blue-800"
                    author={article.author || 'Équipe Giletau'}
                  />
                ))}
              </div>

              {filteredArticles.length === 0 && (
                <div className="text-center py-20">
                  <p className="text-gray-500">Aucun article trouvé dans cette catégorie.</p>
                </div>
              )}
            </>
          )}
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Blog;
